module.exports = __webpack_public_path__ + "static/media/059-saudi-arabia.048813a4.svg";